import { RadioGroup, RadioGroupItem, Label } from '@design-system';
import { cn } from '@client/lib';

export interface RadioOption<T extends string> {
  value: T;
  title: string;
  description: string;
}

interface RadioOptionCardsProps<T extends string> {
  options: RadioOption<T>[];
  value: T | undefined;
  onChange: (value: T) => void;
  className?: string;
  disabled?: boolean;
}

export function RadioOptionCards<T extends string>({
  options,
  value,
  onChange,
  className,
  disabled,
}: RadioOptionCardsProps<T>) {
  return (
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className={cn(className)}
      disabled={disabled}
    >
      {options.map(option => (
        <Label
          key={option.value}
          htmlFor={option.value}
          className={cn(
            'flex items-center justify-between rounded-xl border p-4 transition-all',
            disabled
              ? 'cursor-not-allowed opacity-60'
              : 'hover:border-primary/40 cursor-pointer hover:bg-gray-50',
            value === option.value
              ? 'border-primary bg-primary/5 ring-primary ring-1'
              : 'border-gray-200',
          )}
        >
          <div className="flex-1 pr-4">
            <span className="block text-base font-semibold text-gray-900">{option.title}</span>
            <span className="mt-1 block text-sm text-gray-600">{option.description}</span>
          </div>
          <RadioGroupItem
            value={option.value}
            id={option.value}
            className="shrink-0"
          />
        </Label>
      ))}
    </RadioGroup>
  );
}
